export enum SearchQueryEnum {
  filter = 'f',
  query = 'q',
}
